<template>
	<div class="about">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>关于俱百家</span>
			<div></div>
		</div>
		<!-- 轮播图 -->
		<div class="content">
			<van-swipe :autoplay="3000" indicator-color="white" :height="120">
				<van-swipe-item v-for="item in imgList">
					<img :src="item" alt="">
				</van-swipe-item>
			</van-swipe>
		</div>
		<!-- 列表 -->
		<div class="list">
			<van-cell title="公司简介" is-link to="/profile?id=3" />
			<van-cell title="加盟邀请" is-link to="/profile?id=4" />
			<van-cell title="加盟细则" is-link to="/profile?id=5" />
			<van-cell title="城市运营网点" is-link to="/profile?id=6" />
		</div>
		<!-- 底部 -->
		<div class="footer">
			<div>
				<router-link :to="{path: '_treaty', query: {id: 2}}">隐私政策</router-link>
				<router-link :to="{path: '_treaty', query: {id: 1}}" class="border">服务协议</router-link>
			</div>
			<div>Copyright © 广州俱百家网络科技有限公司</div>
			<div>粤ICP备19077977号</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				imgList: [
					require('../../../assets/class.png'),
					require('../../../assets/class.png'),
					require('../../../assets/class.png'),
					require('../../../assets/class.png')
				]
			}
		}
	}
</script>

<style scoped>
	@import 'about.css';
</style>



// WEBPACK FOOTER //
// src/components/min/about/about.vue